import { defineRule, configure } from 'vee-validate';
import {
    required, integer, min_value, max_value, // eslint-disable-line camelcase
} from '@vee-validate/rules';

defineRule('required', required);
defineRule('integer', integer);
defineRule('min_value', min_value);
defineRule('max_value', max_value);

export function setupVeeValidate(i18n) {
    configure({
        generateMessage: (context) => {
            const locale = i18n.global.locale.value;

            const messages = {
                en: {
                    question1: {
                        required: 'You must specify who you are',
                    },
                    question2: {
                        required: 'You must specify your needs',
                    },
                    question3: {
                        required: 'You must specify your needs',
                    },
                    question4: {
                        required: 'You must choose an option',
                    },
                    question4j0: {
                        required: 'You must choose an option',
                    },
                    question4j1: {
                        required: 'You must choose an option',
                    },
                    question4j2: {
                        required: 'You must choose an option',
                    },
                    nbRides: {
                        required: 'You must specify a number of rides',
                        integer: 'You must enter a valid number of rides',
                        min_value: 'You must enter a valid number of rides',
                    },
                    nbRides0: {
                        required: 'You must specify a number of rides',
                        integer: 'You must enter a valid number of rides',
                        min_value: 'You must enter a valid number of rides',
                    },
                    nbRides1: {
                        required: 'You must specify a number of rides',
                        integer: 'You must enter a valid number of rides',
                        min_value: 'You must enter a valid number of rides',
                    },
                    nbRides2: {
                        required: 'You must specify a number of rides',
                        integer: 'You must enter a valid number of rides',
                        min_value: 'You must enter a valid number of rides',
                    },
                    nbDays5: {
                        required: 'You must specify a number of days',
                        integer: 'You must enter a valid number of days',
                        min_value: 'You must enter a valid number of days (from 1 to 5)',
                        max_value: 'You must enter a valid number of days (from 1 to 5)',
                    },
                    nbDays30: {
                        required: 'You must specify a number of days',
                        integer: 'You must enter a valid number of days',
                        min_value: 'You must enter a valid number of days (from 1 to 30)',
                        max_value: 'You must enter a valid number of days (from 1 to 30)',
                    },
                },
                fr: {
                    question1: {
                        required: 'Vous devez préciser qui vous êtes',
                    },
                    question2: {
                        required: 'Vous devez préciser vos habitudes de déplacements',
                    },
                    question3: {
                        required: 'Vous devez préciser vos habitudes de déplacements',
                    },
                    question4: {
                        required: 'Vous devez choisir une option',
                    },
                    question4j0: {
                        required: 'Vous devez choisir une option',
                    },
                    question4j1: {
                        required: 'Vous devez choisir une option',
                    },
                    question4j2: {
                        required: 'Vous devez choisir une option',
                    },
                    nbRides: {
                        required: 'Vous devez spécifier un nombre de déplacements',
                        integer: 'Vous devez entrer un nombre de déplacements valide',
                        min_value: 'Vous devez entrer un nombre de déplacements valide',
                    },
                    nbRides0: {
                        required: 'Vous devez spécifier un nombre de déplacements',
                        integer: 'Vous devez entrer un nombre de déplacements valide',
                        min_value: 'Vous devez entrer un nombre de déplacements valide',
                    },
                    nbRides1: {
                        required: 'Vous devez spécifier un nombre de déplacements',
                        integer: 'Vous devez entrer un nombre de déplacements valide',
                        min_value: 'Vous devez entrer un nombre de déplacements valide',
                    },
                    nbRides2: {
                        required: 'Vous devez spécifier un nombre de déplacements',
                        integer: 'Vous devez entrer un nombre de déplacements valide',
                        min_value: 'Vous devez entrer un nombre de déplacements valide',
                    },
                    nbDays5: {
                        required: 'Vous devez spécifier un nombre de jours',
                        integer: 'Vous devez entrer un nombre de jours valide',
                        min_value: 'Vous devez entrer un nombre de jours valide (de 1 à 5)',
                        max_value: 'Vous devez entrer un nombre de jours valide (de 1 à 5)',
                    },
                    nbDays30: {
                        required: 'Vous devez spécifier un nombre de jours',
                        integer: 'Vous devez entrer un nombre de jours valide',
                        min_value: 'Vous devez entrer un nombre de jours valide (de 1 à 30)',
                        max_value: 'Vous devez entrer un nombre de jours valide (de 1 à 30)',
                    },
                },
            };

            const fieldMessages = messages[locale]?.[context.field];
            if (fieldMessages && fieldMessages[context.rule.name]) {
                return fieldMessages[context.rule.name];
            }

            return locale === 'fr' ? `${context.field} est invalide` : `${context.field} is invalid`;
        },
        validateOnBlur: true,
        validateOnChange: true,
        validateOnInput: false,
        validateOnModelUpdate: true,
    });
}
